<template>
  <div class="calendar-day" :class="classNames" @click="handleClick">{{ day.date.format('D') }}</div>
</template>

<script>
export default {
  name: 'CalendarDay',
  props: {
    day: Object,
    today: Object
  },
  data () {
    return {
      selected: false
    }
  },
  mounted () {
    if (this.$route.query.nid && this.$route.query.date) {
      this.selected = true
    }
  },
  computed: {
    isThisMonth () {
      return this.day.date.format('M') === this.today.format('M')
    },
    events () {
      return this.day.events
    },
    available () {
      return this.events.filter(event => event.available).length > 0
    },
    isToday () {
      return this.day.date.isSame(this.today, 'day')
    },
    classNames () {
      const classes = []
      if (!this.isThisMonth) {
        classes.push('not-this-month')
      }
      if (this.events.length) {
        classes.push('has-events')
      }
      if (this.available) {
        classes.push('available')
      }
      if (this.selected && this.isToday) {
        classes.push('is-today')
      }
      return classes
    }
  },
  methods: {
    handleClick () {
      this.selected = true
      this.$emit('selectDay', this.day)
    }
  }
}
</script>
<style lang="scss">
.calendar-day {
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;

  &.not-this-month {
    color: var(--gray-darker);
  }
  &.has-events,
  &.is-today {
    font-weight: bold;
  }
  &.has-events {
    background: var(--gray);
    cursor: pointer;
  }
  &.available {
    color: var(--primary-color);
  }
  &.is-today {
    background: var(--primary-color);
    color: #fff;
  }
}
</style>
